<template>
    <div id="app">
        <el-container direction="vertical">
            <Header ref="header" @headerChange="headerChangeEvent" ></Header>
            <Container @containerChange="containerChangeEvent"></Container>
            <Footer v-show="footerShow"></Footer>
        </el-container>
    </div>
</template>

<script>
import Header from './components/layouts/Header'
import Footer from './components/layouts/Footer'
import Container from './components/layouts/Container'

export default {
    name: 'App',
    components: {
        Header,
        Footer,
        Container
    },
    data () {
        return {
            footerShow: false
        }
    },
    methods: {
        headerChangeEvent (status) {
            this.footerShow = status
        },
        containerChangeEvent (status) {
            if (status) {
                this.$refs.header.scrollTop = 10
                this.$refs.header.handleScrollEvent(10)
            } else {
                this.$refs.header.scrollTop = 0
                this.$refs.header.handleScrollEvent(0)
            }
        }
    }
}
</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }
    html, body{
        margin: 0;
        height: 100%;
        /*overflow: hidden;*/
    }
</style>



// WEBPACK FOOTER //
// src/App.vue